import React from 'react';
import PropTypes from 'prop-types';
import MarkdownText from '../../../components/foundations/MarkdownText';
import ArtifactLoader from './ArtifactLoader';
import css from './MarkdownArtifact.css';

const MarkdownArtifact = ({ artifact }) => (
    <ArtifactLoader artifact={artifact}>
        {content => (
            <div className={css.content}>
                {typeof content === 'string' ? (
                    <MarkdownText content={content} />
                ) : (
                    <>
                        <div className={css.errorText}>Invalid markdown format</div>
                        <pre className={css.errorData}>{JSON.stringify(content, null, 2)}</pre>
                    </>
                )}
            </div>
        )}
    </ArtifactLoader>
);

MarkdownArtifact.propTypes = {
    artifact: PropTypes.shape({
        data: PropTypes.string,
        content_url: PropTypes.string,
    }).isRequired,
};

export default MarkdownArtifact;
